<template>
  <div>
    <el-alert
      title="预留扣减可用库存（占用）。发货或领料审核时，如果已有同一来源的预留，就消耗占用，不再二次扣可用。"
      type="info" :closable="false" show-icon style="margin-bottom:12px"
    />
    <div class="toolbar">
      <el-input v-model="query.reservationCode" clearable placeholder="预留单号" style="width:180px" @keyup.enter.native="search" />
      <el-select v-model="query.sourceType" clearable placeholder="来源" style="width:120px">
        <el-option label="手工" value="MANUAL" />
        <el-option label="发货" value="DELIVERY" />
        <el-option label="领料" value="ISSUE" />
      </el-select>
      <el-select v-model="query.reserveState" clearable placeholder="状态" style="width:120px">
        <el-option label="预留中" value="00" />
        <el-option label="已消耗" value="01" />
        <el-option label="已释放" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
    </div>
    <el-table :data="list" border v-loading="loading">
      <el-table-column prop="reservationCode" label="预留单号" width="180" />
      <el-table-column label="来源" width="90">
        <template slot-scope="{ row }">{{ sourceName(row.sourceType) }}</template>
      </el-table-column>
      <el-table-column prop="sourceBizCode" label="来源单号" min-width="160" show-overflow-tooltip />
      <el-table-column label="状态" width="90" align="center">
        <template slot-scope="{ row }">
          <el-tag size="small" :type="row.reserveState === '00' ? 'warning' : (row.reserveState === '01' ? 'success' : 'info')">
            {{ stateName(row.reserveState) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createByName" label="制单人" width="100" />
      <el-table-column prop="createDate" label="制单时间" width="170" />
      <el-table-column label="操作" width="140" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row.reservationId)">明细</el-button>
          <el-button type="text" :disabled="row.reserveState !== '00'" @click="doRelease(row)">释放</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination :total="total" :page="page" :page-size="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="onPage" @size-change="onSize" />

    <el-dialog title="预留明细" :visible.sync="detailVisible" width="860px">
      <el-table :data="(detail && detail.lineList) || []" border size="small">
        <el-table-column prop="productNumber" label="产品编码" width="120" />
        <el-table-column prop="productName" label="产品名称" min-width="140" />
        <el-table-column prop="wareHouseName" label="仓库" width="120" />
        <el-table-column prop="batchNo" label="批次" width="120" />
        <el-table-column prop="wareAreaName" label="库位" width="100" />
        <el-table-column prop="quantity" label="预留数量" width="100" align="right" />
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listReservation, getReservation, releaseReservation } from '../../api/reservation'

export default {
  components: { ListPagination },
  data() {
    return {
      query: { reservationCode: '', sourceType: '', reserveState: '' },
      list: [], total: 0, page: 1, pageSize: 20, loading: false,
      detailVisible: false, detail: null
    }
  },
  created() { this.load() },
  methods: {
    sourceName(type) {
      if (type === 'MANUAL') return '手工'
      if (type === 'DELIVERY') return '发货'
      if (type === 'ISSUE') return '领料'
      return type || ''
    },
    stateName(state) {
      if (state === '00') return '预留中'
      if (state === '01') return '已消耗'
      if (state === '02') return '已释放'
      return state || ''
    },
    search() { this.page = 1; this.load() },
    onPage(p) { this.page = p; this.load() },
    onSize(s) { this.pageSize = s; this.page = 1; this.load() },
    load() {
      this.loading = true
      listReservation({
        currentPage: this.page, pageSize: this.pageSize,
        reservationCode: this.query.reservationCode, sourceType: this.query.sourceType, reserveState: this.query.reserveState
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    openDetail(id) {
      getReservation(id).then(res => {
        this.detail = res.data || { lineList: [] }
        this.detailVisible = true
      })
    },
    doRelease(row) {
      this.$confirm('释放预留将恢复可用库存，继续？', '提示', { type: 'warning' }).then(() => {
        releaseReservation(row.reservationId).then(() => {
          this.$message.success('已释放')
          this.load()
        })
      }).catch(() => {})
    }
  }
}
</script>
